export const SCHEDULED_EMAILS_URL: string = 'account/{accountId}/event/{eventId}/scheduled-emails';
export const MUTATE_SCHEDULED_EMAIL_URL: string = `${SCHEDULED_EMAILS_URL}/{id}`;
export const SEND_EMAIL_PREVIEW: string = 'account/{accountId}/event/{eventId}/scheduled-emails/{id}/preview';
export const SEND_EMAIL_MEETING_PREVIEW: string = 'account/{accountId}/event/{eventId}/scheduled-emails/{id}/preview?meetingId={meetingId}';
